import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import DesktopView from './desktop-view';
import NewDesktopView from './new-desktop-view';
import LowResolutionView from '../common/low-resolution-view';

export default function Main({
  partnership,
  mobileImageUrl,
  newDashboard,
}) {
  const { isLowResolution } = React.useContext(ThemeContext);

  if (isLowResolution) {
    return <LowResolutionView type="performance" mobileImageUrl={mobileImageUrl} />;
  }

  return newDashboard ? <NewDesktopView partnership={partnership} />
    : <DesktopView partnership={partnership} />;
}

Main.propTypes = {
  partnership: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    cachedAnalyticsDataUrls: PropTypes.shape({
      followersDataUrl: PropTypes.string,
      contributorRankingDataUrl: PropTypes.string,
      investorTypesDataUrl: PropTypes.string,
    }),
    contributors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
      createdAt: PropTypes.string,
    })).isRequired,
  }).isRequired,
  mobileImageUrl: PropTypes.string.isRequired,
  newDashboard: PropTypes.bool.isRequired,
};
